/* StartEcom home/collection/info behaviour: wordmark fit, reveal, tabs, buy-box swatches. No dependencies. */
(() => {
  if (window.seHome) return;
  window.seHome = true;
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Giant wordmarks: fit the text to its box width.
  const fit = () => $$('[data-se-fit]').forEach((el) => {
    const span = el.firstElementChild;
    if (!span) return;
    el.style.fontSize = '100px';
    const w = span.getBoundingClientRect().width;
    if (w) el.style.fontSize = `${Math.floor((100 * el.clientWidth) / w * 0.995)}px`;
  });

  // Reveal on scroll (once). Everything shows at once for reduced motion or automation.
  const reveal = () => {
    const els = $$('.se-h .se-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || navigator.webdriver || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  };

  // Tabs (tabbed product rails): buttons[aria-controls] switch panels.
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-se-tab]');
    if (!tab) return;
    const list = tab.closest('[role=tablist]');
    $$('[data-se-tab]', list).forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  });

  // Carousel arrows: scroll the section's rail by most of its width.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-se-rail]');
    if (!btn) return;
    const rail = btn.closest('.se-prods')?.querySelector('.se-prods__panel:not([hidden]) .se-rail');
    if (rail) rail.scrollBy({ left: Number(btn.dataset.seRail) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  // Featured buy box: a colour radio swaps the main photo.
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-se-swatch]');
    if (!r) return;
    const box = r.closest('[data-se-buy]');
    const img = box && box.querySelector('.se-buy__slide img');
    if (img && r.dataset.src) { img.src = r.dataset.src; img.removeAttribute('srcset'); }
    const gallery = box && box.querySelector('.se-buy__gallery');
    if (gallery && gallery.scrollLeft) gallery.scrollTo({ left: 0, behavior: 'smooth' });
    const name = box && box.querySelector('[data-se-colour]');
    if (name) name.textContent = r.dataset.name || '';
  });

  // Collection "Load more": fetch the next page and append its cards.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-se-more]');
    if (!a || !window.fetch) return;
    e.preventDefault();
    const sec = a.closest('.se-cg');
    a.setAttribute('aria-busy', 'true');
    fetch(a.href).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.getElementById(sec.id);
      const grid = next && next.querySelector('.se-cg__grid');
      if (grid) sec.querySelector('.se-cg__grid').append(...grid.children);
      const more = next && next.querySelector('[data-se-more]');
      if (more) { a.href = more.href; a.removeAttribute('aria-busy'); } else a.remove();
    }).catch(() => { location.href = a.href; });
  });

  const init = () => {
    // Automated previews (headless screenshots) never scroll, so load every photo up front there.
    if (navigator.webdriver) $$('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
    fit();
    reveal();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  addEventListener('resize', fit);
  if (document.fonts) document.fonts.ready.then(fit);
  document.addEventListener('shopify:section:load', init);
})();
